import { Box, Grid } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { timeFormat } from "utils/commonUtils";

const WebcallbackGridSlots = (props) => {
  const { timeSlotsToDisplay, handleChange, language } = props;

  return (
    <Grid container spacing={1} className="fr-ml-n1w">
      {timeSlotsToDisplay.map((slot) => (
        <Grid key={slot} size={{ xs: 6, sm: 4, md: 3, lg: language === "EN" ? 12 : 6 }}>
          <Box
            component="button"
            type="button"
            key={slot}
            name="startDate"
            value={slot}
            className="fr-btn fr-btn--tertiary"
            onClick={handleChange}
            sx={{ width: "100%", justifyContent: "center" }}
          >
            {timeFormat({ date: slot, lang: language })}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

WebcallbackGridSlots.propTypes = {
  timeSlotsToDisplay: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleChange: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
};

export default WebcallbackGridSlots;
